function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M27.75 21.32H46.8c.63 0 1.14-.5 1.14-1.14V1.14C47.94.51 47.43 0 46.8 0h-4.57c-.63 0-1.14.51-1.14 1.14v7.43A23.51 23.51 0 0023.4.77a23.57 23.57 0 1016 41.04c.5-.45.52-1.2.05-1.66l-3.23-3.23a1.14 1.14 0 00-1.55-.05A16.72 16.72 0 1123.58 7.6a16.7 16.7 0 0113.52 6.87h-9.35c-.63 0-1.14.51-1.14 1.14v4.56c0 .63.51 1.14 1.14 1.14z",
  fillRule: "evenodd"
})));